import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { AvisInitialTypeLight } from '../models/AvisInitialTypeLight';
@Component({
	selector: 'app-avis-initial-type',
	templateUrl: './avis-initial-type.component.html'
})
export class AvisInitialTypeComponent implements OnInit {
	@Input() uid = '';
	public current_uid = 'AvisInitialType';
	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	@Input() avisInitial: AvisInitialTypeLight;

	public rg1 = 'CTRL_IDWEB';

	constructor() {}

	public ngOnInit() {
		this.parentForm.addControl(this.getStepId() + this.rg1, new FormControl({ rgCtrls: this.getCtrl_idWebNames_json() }));
	}

	getUid() {
		return this.uid + '_SepSep_' + this.current_uid;
	}

	getStepId() {
		return this.uid.substring(0, this.uid.indexOf("SepSep"));
	  }
  
	getCtrl_idWebNames_json(): any {
	  return { idWeb: "_SepSep_AttributionFromFNSimple_SepSep_AvisInitialType_SepAtt_idWeb" };
	}
}
